import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@BUP/hooks';
import { isModeBup, isWebinars, isData } from '@BUP/services/BraveUp';
import { RBAC } from '@BUP/components';
import { useTranslation } from 'react-i18next';

const Navigation = () => {
  const { user } = useAuth();
  const roleUser = user?.roles?.type;
  const [t] = useTranslation();

  return (
    <nav>
      <div className="nav-element-wrapper">
        <NavLink exact className="nav-link" to="/">
          {t('nav.home')}
        </NavLink>
      </div>
      {roleUser === 'TEACHER' ? (
        <div className="nav-element-wrapper">
          <NavLink className="nav-link" to="/course">
            {t('nav.myClass')}
          </NavLink>
        </div>
      ) : null}
      <div className="nav-element-wrapper">
        <NavLink className="nav-link" to="/resources">
          {t('nav.resources')}
        </NavLink>
      </div>
      {isWebinars(user) ? (
        <div className="nav-element-wrapper">
          <RBAC name="navWebinars">
            <NavLink className="nav-link " to="/webinars">
              {t('nav.webinars')}
            </NavLink>
          </RBAC>
        </div>
      ) : null}
      {isModeBup(user) ? (
        <div className="nav-element-wrapper" style={{ marginBottom: 25 }}>
          <NavLink className="nav-link" to="/modebup">
            {t('nav.bupmode')}
          </NavLink>
          <RBAC name="navModeBupSendLink">
            <NavLink
              className="sub-nav-link"
              to="/modebup/send"
              style={{ marginTop: 14 }}
            >
              {t('nav.sendMessage')}
            </NavLink>
          </RBAC>
          <NavLink className="sub-nav-link" to="/modebup/inbox">
            {t('nav.inbox')}
          </NavLink>
          <RBAC name="navModeBupArchivedLink">
            <NavLink className="sub-nav-link" to="/modebup/archived">
              {t('nav.archivedCases')}
            </NavLink>
          </RBAC>
        </div>
      ) : null}
      {isData(user) ? (
        <div className="nav-element-wrapper">
          <NavLink className="nav-link" to="/data">
            {t('nav.data')}
          </NavLink>
        </div>
      ) : null}
    </nav>
  );
};

export default Navigation;
